import { useEffect, useRef, useState } from 'react';
import QRCodeStyling from 'qr-code-styling';

type RoundedQRCodeProps = {
  value: string;
  size?: number;
};

export function RoundedQRCode({ value, size = 72 }: RoundedQRCodeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !value) return;

    try {
      container.innerHTML = '';
      setHasError(false);

      const qrCode = new QRCodeStyling({
        width: size,
        height: size,
        type: 'svg',
        data: value,
        margin: 0,
        qrOptions: {
          errorCorrectionLevel: 'M',
        },
        dotsOptions: {
          type: 'dots',
          color: '#000000',
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
          color: '#000000',
        },
        cornersDotOptions: {
          type: 'dot',
          color: '#000000',
        },
        backgroundOptions: {
          color: '#ffffff',
        },
      });

      qrCode.append(container);
    } catch {
      // QR üretilemezse giriş ekranını bozma
      setHasError(true);
      container.innerHTML = '';
    }
  }, [value, size]);

  return (
    <div
      ref={containerRef}
      style={{
        width: size,
        height: size,
        lineHeight: 0,
        display: hasError ? 'none' : undefined,
      }}
    />
  );
}
